export class con  {

public static codArancel(){
        let cod : number = 21;        
        return cod;
    }

    public static codMatricula(){
        let cod : number = 20;        
        return cod;
    }

  public static codExceptionFirma() {
        let tipoExcepcion: number = 0;
        let codExcepcion: number = 0;
        tipoExcepcion = 1;
        codExcepcion = 1;        
        return `${tipoExcepcion},${codExcepcion}`;
    }

    public static codExceptionTransferencia() {
        let tipoExcepcion: number = 0;
        let codExcepcion: number = 0;
        tipoExcepcion = 2;
        codExcepcion = 3;        
        return `${tipoExcepcion},${codExcepcion}`;
    }

    public static codDocumentoContrato() {
        let cod: number = 0;
        cod = 4;        
        return cod;
    }

    public static codTransferencia() {
        let cod: number = 0;
        cod = 23;        
        return cod;
    }

    public static idEstadoInicialComprobante() {
        let cod: number = 0;
        cod = 1;        
        return cod;
    }

    public static idEstadoRechazadaComprobante() {
        let cod: number = 0;
        cod = 4;        
        return cod;
    }

    public static idEstadoAceptadaComprobante() {
        let cod: number = 0;
        cod = 2;        
        return cod;
    }

    public static carrerasMensajeriaRF() {
        let cod: string[] = ["1101C", "1101CL","2009S","2009SA"];        
        return cod;
    }

    public static RetornaRuta(){
        let ruta:string = "";
        //ruta="http://localhost:10680/api/";
        //ruta="https://localhost:44314/api/"; 
        ruta="https://api-gw.udd.cl/finanzasip/api/";
        
        return ruta;
    }

    public static mnsjeCert(){
        let cod : boolean = false;
        return cod;
    }

    public static mensajeeCert(){
        let mnsj: string = 'El Registro Civil ha informado de una mantención en su sistema hoy entre las 18:00 y las 21:00 hrs., que puede generar algún inconveniente para firmar de manera electrónica. Si estás en esta situación, comunícate con nosotros al 800200125 opción 2 y te asistiremos.'
        return mnsj;
    }

    public static RetornaRutaBeneficios() {
        let ruta: string = '';
        ruta = "https://api-gw.int.udd.cl/beneficios/api/";

        return ruta;
    }

    public static RetornaRutaBFF(){
        let ruta:string = "";
        ruta="https://api-gw-ext.udd.cl/finanzas_bff_matricula/api/";
        
        return ruta;
    }
}
